export default __webpack_public_path__ + "static/media/suit-1.3e766cea.jpg";